import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Dock, DockIcon } from './ui/Dock'

export default function DockNav() {
  const location = useLocation()

  const navItems = [
    {
      id: 'about',
      href: '/about',
      label: 'About',
      isActive: location.pathname === '/about',
    },
    {
      id: 'projects',
      href: '/projects',
      label: 'Projects',
      isActive:
        location.pathname.startsWith('/projects') ||
        location.pathname.startsWith('/website-design-development') ||
        location.pathname.startsWith('/graphic-design') ||
        location.pathname.startsWith('/video-editing'),
    },
  ]

  return (
    <Dock direction="middle" className="bg-black/80 border-white/20 px-6 py-4">
      {navItems.map((item) => (
        <DockIcon
          key={item.id}
          className={`mx-2 ${item.isActive ? 'text-[#E06100]' : 'text-white hover:bg-white/20'}`}
        >
          <Link to={item.href} className="text-sm font-medium px-4 py-2">
            {item.label}
          </Link>
        </DockIcon>
      ))}
    </Dock>
  )
}